module.exports = __webpack_public_path__ + "img/shui.901fcb9f.png";